import axios from "axios";
import logger from "../utils/logger";

const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  withCredentials: true,
  timeout: 25000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const message = err.response?.data?.message || err.message;

    logger.error(`API Error [${status || "Network"}]: ${message}`, err.response?.data);

    if (status === 401) {
      localStorage.removeItem("user");

      if (typeof window !== "undefined") {
        localStorage.removeItem("user");
        localStorage.removeItem("tokenExpiry");
        window.dispatchEvent(new CustomEvent("tokenExpired"));
        // Redirect if not already on login page
        if (!window.location.pathname.includes("/login")) {
          window.location.href = "/login";
        }
      }

      window.location.href = "/login";
    } else if (status === 403) {
      logger.warn("Access forbidden. User may not have necessary permissions.");
    } else if (status === 404) {
      logger.warn(`Resource not found: ${err.config?.url}`);
    } else if (status >= 500) {
      logger.error("Server error encountered. Please try again later.");
    }

    return Promise.reject(err);
  }
);

export default axiosInstance;